import { AssetMimeTypes, assetMimeTypes } from '@cube3/common/model/types';
import { capitalize } from '@material-ui/core';

export const makeReadableMimeTypeName = (my: AssetMimeTypes) => {
  if (!my) return '';
  const name = my
    .replace('application/', '')
    .replace('vnd.cube.', '')
    .replace('document.', '')
    .replace('share.', '')
    .replace('request', 'File Request');
  return capitalize(name);
};
/**  creating a category requires either an `asset_type_id` attribute or a `for_mime_type` attribute (a full "cube mimetype"..)
 * - currently only support these types
 */
export const supportedMimeTypes = [
  {
    id: 2,
    value: assetMimeTypes.PROJECT,
    display_name: makeReadableMimeTypeName(assetMimeTypes.PROJECT)
  },
  {
    id: 3,
    value: assetMimeTypes.VIDEO,
    display_name: makeReadableMimeTypeName(assetMimeTypes.VIDEO)
  },
  {
    id: 6,
    value: assetMimeTypes.AUDIO,
    display_name: makeReadableMimeTypeName(assetMimeTypes.AUDIO)
  },
  {
    id: 8,
    value: assetMimeTypes.IMAGE,
    display_name: makeReadableMimeTypeName(assetMimeTypes.IMAGE)
  },
  {
    id: 9,
    value: assetMimeTypes.DOCUMENT_PDF,
    display_name: makeReadableMimeTypeName(assetMimeTypes.DOCUMENT_PDF)
  },
  // not available in backend yet
  // {
  //   id: assetMimeTypes.FILREQUEST,
  //   value: assetMimeTypes.FILREQUEST,
  //   display_name: makeReadableMimeTypeName(assetMimeTypes.FILREQUEST)
  // },

];
